module.exports = {"110111001":"城关街道","110111002":"新镇街道","110111004":"向阳街道","110111005":"东风街道","110111006":"迎风街道","110111007":"星城街道","110111008":"良乡地区","110111009":"周口店地区","110111010":"琉璃河地区","110111011":"拱辰街道","110111012":"西潞街道","110111101":"阎村镇","110111103":"窦店镇","110111104":"石楼镇","110111105":"长阳镇","110111107":"河北镇","110111108":"长沟镇","110111109":"大石窝镇","110111110":"张坊镇","110111111":"十渡镇","110111112":"青龙湖镇","110111115":"韩村河镇","110111208":"霞云岭乡","110111209":"南窖乡","110111210":"佛子庄乡","110111211":"大安山乡","110111212":"史家营乡","110111213":"蒲洼乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110111.json
// module id = 114
// module chunks = 0